var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQwincySummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0816 8.85524L21.9375 6.95941L23.8333 6.10357C24.2558 5.90857 24.2558 5.31274 23.8333 5.11774L21.9375 4.26191L21.0816 2.35524C20.8866 1.93274 20.2908 1.93274 20.0958 2.35524L19.24 4.25107L17.3333 5.10691C16.9108 5.30191 16.9108 5.89774 17.3333 6.09274L19.2291 6.94857L20.085 8.85524C20.28 9.27774 20.8866 9.27774 21.0816 8.85524ZM12.4583 10.4802L10.7358 6.68857C10.3566 5.84357 9.14329 5.84357 8.76413 6.68857L7.04163 10.4802L3.24996 12.2027C2.40496 12.5927 2.40496 13.7952 3.24996 14.1744L7.04163 15.8969L8.76413 19.6886C9.15413 20.5336 10.3566 20.5336 10.7358 19.6886L12.4583 15.8969L16.25 14.1744C17.095 13.7844 17.095 12.5819 16.25 12.2027L12.4583 10.4802ZM20.085 17.5219L19.2291 19.4177L17.3333 20.2736C16.9108 20.4686 16.9108 21.0644 17.3333 21.2594L19.2291 22.1152L20.085 24.0219C20.28 24.4444 20.8758 24.4444 21.0708 24.0219L21.9266 22.1261L23.8333 21.2702C24.2558 21.0752 24.2558 20.4794 23.8333 20.2844L21.9375 19.4286L21.0816 17.5219C20.8866 17.0994 20.28 17.0994 20.085 17.5219Z",
    fill: "#1A4BF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQwincySummary);
export default __webpack_public_path__ + "static/media/qwincy-summary.75fdb8fc1d7f844695d99ed7c2fb15da.svg";
export { ForwardRef as ReactComponent };